<mat-toolbar class="main-header">
  <button mat-icon-button (click)="goBack()">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <span>Ranking de dianas</span>
</mat-toolbar>

<div class="group-bar">
  <div class="group-bar-scroll">
    <button
      type="button"
      class="group-chip"
      [class.active]="groupSelected === 'general'"
      (click)="selectGroup('general')"
    >
      🌍 General
    </button>
    @for (group of groups; track group) {
      <button
        type="button"
        class="group-chip"
        [class.active]="groupSelected === group._id"
        (click)="selectGroup(group._id)"
      >
        {{ group.name }}
      </button>
    }
  </div>
</div>

<div class="stats-snipers-page">
  @if (snipers.length === 0) {
    <div class="empty-state">
      <mat-icon>sports_score</mat-icon>
      <p>Todavía no hay dianas registradas en este grupo.</p>
    </div>
  }

  @for (sniper of snipers; track sniper.userId; let i = $index) {
    <button
      type="button"
      class="sniper-card"
      [class.is-me]="sniper.user._id === loggedUser?._id"
      (click)="selectUser(sniper.user._id)"
    >
      <div class="sniper-rank">{{ i + 1 }}</div>
      <app-avatar [user]="sniper.user"></app-avatar>
      <div class="sniper-copy">
        <div class="sniper-name">{{ sniper.user.name }}</div>
        <div class="sniper-meta">
          {{ sniper.sniper }} dianas
          @if (sniper.points !== undefined && sniper.points !== null) {
            <span>· {{ sniper.points }} pts</span>
          }
        </div>
      </div>
      <mat-icon>chevron_right</mat-icon>
    </button>
  }
</div>
